import React from "react";

const ColourModeContext = React.createContext({ toggleColorMode: () => {} });

export default ColourModeContext;
